import React from 'react';
import { BarChart3, Package, Target } from 'lucide-react';
import group from "../../../assests/Group3702.png";
import group1 from "../../../assests/Vector.png";
import circle from "../../../assests/semicircle.png";



export const MetricCard = ({
  title = '',
  value,
  subtitle = '',
  variant = 'default',
  className = '',
  performance = 92,
  icon = null
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          borderColor: 'border-[#E30073]',
          iconBg: 'bg-[#E30073]',
          progressBg: 'bg-[#E30073]',
          progressTrack: 'bg-gray-200'
        };
      case 'success':
        return {
          borderColor: 'border-[#63B945]',
          iconBg: 'bg-[#63B945]',
          progressBg: 'bg-[#63B945]',
          progressTrack: 'bg-gray-200'
        };
      case 'warning':
        return {
          borderColor: 'border-[#FE8D19]',
          iconBg: 'bg-[#FE8D19]',
          progressBg: 'bg-[#FE8D19]',
          progressTrack: 'bg-gray-200'
        };
      default:
        return {
          borderColor: 'border-gray-500',
          iconBg: 'bg-gray-500',
          progressBg: 'bg-gray-500',
          progressTrack: 'bg-gray-200'
        };
    }
  };

  const getIcon = () => {
    if (icon) return icon;
    
    switch (variant) {
      case 'primary':
        return <img src={group} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      case 'success':
        return <img src={group1} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      case 'warning':
        return <img src={circle} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      default:
        return <BarChart3 className="w-10 text-white" />;
    }
  };

  const styles = getVariantStyles();

  return (
    <div className={`bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 ${className}`} style={{
        borderTop: '1px solid #d1d5db',
      borderLeft: '1px solid #d1d5db',
      borderRight: '1px solid #d1d5db',
      borderBottom: '1px solid #d1d5db'
    }}>
  <div className="py-6 pl-6 flex relative  justify-between items-center">
  <div className="w-[60%]">
    <div className="text-6xl font-bold text-gray-900 mb-1">
      {value}
    </div>
    <h3 className="text-md font-semibold text-gray-900">
      {title}
    </h3>
  </div>
  <div className="absolute top-0 bottom-0 left-[60%] w-px bg-[#D9D9D9]" />

  <div className={`w-[40%] flex justify-center items-center}`}>
    <div className={`w-[50px] h-[60px] rounded-lg flex items-center justify-center ${styles.iconBg}`}>
      {getIcon()}
    </div>
  </div>
</div>

    </div>
  );
};